import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getTransferList,
	addNewTransfer,
	updateTransfer,
	deleteTransfer,
	getTransfer,
} from '../transfer/thunk';

export const initialState = {
	itemTransferList: [],
	itemTransferDetail: null,
	isTransferLoading: false,
	isTransferSuccess: false,

	transferList: [],
	transferListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const TransferSlice = createSlice({
	name: 'Transfers',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getTransfer.fulfilled, (state, action) => {
			state.isTransferLoading = false;
			state.isTransferSuccess = true;
			state.itemTransferDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getTransfer.pending, state => {
			state.isTransferLoading = true;
			state.isTransferSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getTransfer.rejected, (state, action) => {
			state.isTransferLoading = false;
			state.isTransferSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getTransferList.pending, state => {
			state.isTransferSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getTransferList.fulfilled, (state, action) => {
			state.itemTransferList = action.payload;
			state.transferList = action.payload;
			state.isLoadingList = false;
			state.isTransferSuccess = true;

			let transferListSelect = [];
			action.payload.map(item =>
				transferListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.transferListSelect = transferListSelect;
		});
		builder.addCase(getTransferList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isTransferSuccess = true;
		});
		builder.addCase(addNewTransfer.fulfilled, (state, action) => {
			state.itemTransferList.push(action.payload);
			state.transferList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewTransfer.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewTransfer.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateTransfer.fulfilled, (state, action) => {
			state.itemTransferList = state.itemTransferList.map(transfer =>
				transfer.transfername === action.payload.old_transfer
					? { ...transfer, ...action.payload.updated_transfer }
					: transfer
			);
			state.transferList = state.transferList.map(transfer =>
				transfer._id.toString() === action.payload._id.toString()
					? { ...transfer, ...action.payload }
					: transfer
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateTransfer.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateTransfer.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteTransfer.fulfilled, (state, action) => {
			state.itemTransferList = current(state.itemTransferList).filter(
				item => item._id !== action.payload._id
			);
			state.transferList = current(state.transferList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteTransfer.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteTransfer.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const { setRequireCloseModal } = TransferSlice.actions;

export default TransferSlice.reducer;